var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('div',{staticClass:"text-center"},[_c('h1',[_vm._v("Vulnerability assessment for SQL Server")])])])}
var staticRenderFns = []

export { render, staticRenderFns }